module.exports = __webpack_public_path__ + "static/media/list.5d374252.svg";